import { NIVELES, nivelDeSemanas } from './semanas'

interface Props {
  semanas: number
  /** En las tarjetas la unidad se escribe entera; en la tabla la da la columna. */
  conUnidad?: boolean
}

/**
 * Las semanas sin pedir, destacadas cuando pasan de un umbral. El color va
 * **siempre acompanado de la palabra**: hay operadores que no distinguen bien
 * los colores, y una celda ambar y una roja les llegan iguales.
 */
export function MarcaSemanas({ semanas, conUnidad = false }: Props) {
  const { etiqueta, clase } = NIVELES[nivelDeSemanas(semanas)]
  const texto = conUnidad ? `${semanas} ${semanas === 1 ? 'semana' : 'semanas'}` : String(semanas)

  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <span className="font-semibold tabular-nums text-tinta">{texto}</span>
      {etiqueta ? (
        <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${clase}`}>{etiqueta}</span>
      ) : null}
    </span>
  )
}
